export default __webpack_public_path__ + "static/media/empty-ui.d514033c.svg";